import React, { useState, useEffect, useContext } from "react";
import { Accordion } from "../../components/Accordion/";
import AccordionFaq from "../../components/Accordion/accordionFaq";
import Table from "../../components/Table/index";
import { AiOutlineCheck } from "react-icons/ai";
import { AiOutlineClose } from "react-icons/ai";
import { useSelector } from "../../native-state.dev";
import axios from "axios";
import { getConfig } from "../../config/config";
import { LoginContext } from "../../contexts/login_context";
import { FaPlus, FaSave, FaTrash } from "react-icons/fa";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import Loading from "../../components/Loading"; // <-- ajuste o caminho se necessário

export const data = [
  {
    "Verified by GS1": <AiOutlineCheck />,
    "Cadastro Nacional de Produtos": <AiOutlineClose />,
    GEPIR: <AiOutlineCheck />,
    Descrição:
      "O código é valido. Para compartilhamento de atributos como por exemplo, NCM, CEST, Peso bruto é preciso que o dono da marca entre em contato com a GS1 Brasil",
  },
  {
    "Verified by GS1": <AiOutlineCheck />,
    "Cadastro Nacional de Produtos": <AiOutlineClose />,
    GEPIR: <AiOutlineClose />,
    Descrição:
      "Nesse momento o status do código é inválido. A empresa dona da marca do produto precisa entrar em contato com a GS1 Brasil.",
  },
  {
    "Verified by GS1": <AiOutlineClose />,
    "Cadastro Nacional de Produtos": <AiOutlineCheck />,
    GEPIR: <AiOutlineCheck />,
    Descrição:
      "O código é valido, porém, a empresa não permitiu o compartilhamento dos dados do produto em uma base global",
  },
  {
    "Verified by GS1": <AiOutlineClose />,
    "Cadastro Nacional de Produtos": <AiOutlineClose />,
    GEPIR: <AiOutlineCheck />,
    Descrição:
      "O código é válido, porém a empresa não permite o compartilhamento dos dados do produto",
  },
];

// ---- Tipagem do item de FAQ
type FaqItem = {
  id?: number | string;
  question: string;
  answer: string;
  enabled: boolean;
  isNew?: boolean; // flag para diferenciar item novo x existente
};

const Faq = () => {
  let gs1_brasil_url: string =
    "<a href='mailto:atendimento@gs1br.org' target='_blank'>GS1 Brasil</a>";

  const [modalObje, setState] = useSelector(
    (s: { searchDone: any }) => s.searchDone
  );
  const [questions, setQuestions] = useState<FaqItem[]>([]);
  const [editingQuestions, setEditingQuestions] = useState<FaqItem[]>([]);
  const [allQuestions, setAllQuestions] = useState<FaqItem[]>([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedEditIndex, setSelectedEditIndex] = useState<number | null>(
    null
  );
  const [loading, setLoading] = useState(false); // <-- estado de loading global

  const { jwt, perfil, empresaId } = useContext(LoginContext);

  async function getPerguntasFrequentes(): Promise<any> {
    try {
      const response = await axios.get(
        getConfig().API_URL + "/consultaPerguntasFrequentes",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt}`,
          },
        }
      );

      return { success: true, message: "", result: response };
    } catch (error: any) {
      console.error("Error fetching perguntas frequentes:", error);
      if (error.response) {
        console.error("Response error:", error.response.data);
        console.error("Response status:", error.response.status);
      }
      if (error) return { success: false, message: error.message };
    }

    return {
      success: false,
      message: "Erro desconhecido. Tente novamente mais tarde.",
      result: "",
    };
  }

  // Create a new FAQ question (local, abre já para edição)
  const createNewQuestion = async () => {
    const newItem: FaqItem = {
      id: `new-${Date.now()}`, // id temporário (apenas para React key)
      question: "",
      answer: "",
      enabled: true,
      isNew: true,
    };

    // insere no topo e já abre
    setEditingQuestions((prev) => [newItem, ...prev]);
    setSelectedEditIndex(0);
  };

  const saveEditedQuestion = async (index: number) => {
    try {
      setLoading(true); 
      const question = editingQuestions[index];
      const payload = {
        id: question.id,
        question: question.question,
        answer: question.answer,
        enabled: question.enabled,
      };

      if (question.isNew) {
        // CRIAÇÃO
        await axios.post(
          `${getConfig().API_URL}/criarPerguntaFrequente`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${jwt}`,
            },
          }
        );
      } else {
        // EDIÇÃO
        await axios.post(
          `${getConfig().API_URL}/editarPerguntaFrequente`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${jwt}`,
            },
          }
        );
      }

      // Refetch para sincronizar estado e limpar isNew
      const result = await getPerguntasFrequentes();
      if (result.success && result.result) {
        const q: FaqItem[] = result.result.data.data;
        setAllQuestions(q);
        const enabledQuestions = q.filter((q: FaqItem) => q.enabled === true);
        setQuestions(enabledQuestions);
        setEditingQuestions(q.map((item) => ({ ...item, isNew: false })));
      }

      setSelectedEditIndex(null);
    } catch (error) {
      console.error("Error saving question:", error);
      alert("Erro ao salvar pergunta. Tente novamente.");
    } finally {
      setLoading(false); // <-- encerra loading
    }
  };

  // Delete a question (se novo: remove do estado; se existente: nada)
  const deleteQuestion = async (index: number) => {
    try {
      const q = editingQuestions[index];
      if (!q?.isNew) {
        setSelectedEditIndex(null);
        return;
      }
      const clone = [...editingQuestions];
      clone.splice(index, 1);
      setEditingQuestions(clone);
      setSelectedEditIndex(null);
    } catch (error) {
      console.error("Error deleting local question:", error);
      alert("Erro ao excluir pergunta. Tente novamente.");
    }
  };

  // Toggle edit mode
  const toggleEditMode = () => {
    if (isEditMode) {
      setIsEditMode(false);
      setSelectedEditIndex(null);
    } else {
      // garante que os itens carregados estejam como existentes
      const prepared = allQuestions.map((q) => ({ ...q, isNew: false }));
      setEditingQuestions(prepared);
      setIsEditMode(true);
    }
  };

  // Update a specific question in editing mode
  const updateQuestion = (
    index: number,
    field: string,
    value: string | boolean
  ) => {
    const updatedQuestions = [...editingQuestions];
    updatedQuestions[index] = {
      ...updatedQuestions[index],
      [field]: value,
    };
    setEditingQuestions(updatedQuestions);
  };

  // Toggle selected question in edit mode
  const toggleEditQuestion = (index: number) => {
    setSelectedEditIndex(selectedEditIndex === index ? null : index);
  };

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        setLoading(true); // <-- inicia loading do GET inicial
        const result = await getPerguntasFrequentes();

        if (result.success && result.result) {
          const q: FaqItem[] = result.result.data.data;
          setAllQuestions(q);
          const enabledQuestions = q.filter((q: FaqItem) => q.enabled === true);
          setQuestions(enabledQuestions);
        } else {
          console.error("Failed to fetch questions:", result.message);
        }
      } catch (error) {
        console.error("Error in fetchQuestions:", error);
      } finally {
        setLoading(false); // <-- encerra loading
      }
    };

    fetchQuestions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Mantém seu comportamento existente
  setState({ searchDone: false });

  const [selectedIndex, setSelectedIndex] = useState(-1);

  const changeSelectedIndex = (id: number) => {
    if (id !== selectedIndex) {
      setSelectedIndex(id);
    } else {
      setSelectedIndex(-1);
    }
  };

  return (
    <>
      {/* Overlay/placeholder de loading global */}
      {loading && <Loading />}

      <div className="container-fluid" aria-busy={loading}>
        <div className="row">
          <div className=" ms-fullWidth" style={{ width: "100%" }}>
            <div className="">
              <div
                className="banner"
                style={{ backgroundImage: `url("./filtrado.jpg")` }}
              >
                <div className="container">
                  <div className="row">
                    <div className="col-12 col-md-8 py-5">
                      <div className="gs1-h1 d-flex justify-content-between align-items-center">
                        Perguntas Frequentes
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div aria-busy={loading}>
        <div className="container">
          <div className="row bg-color-white px-4 rounded-lg">
            <div className="col-12">
              <h3 className="title d-flex justify-content-between align-items-center">
                ​​​Veja quais são as dúvidas mais comuns sobre o Verified by GS1
                {perfil && perfil.indexOf("GS1") >= 0 && (
                  <button
                    className="btn btn-outline-primary"
                    onClick={toggleEditMode}
                    disabled={loading} // <-- evita alternar enquanto salva/carrega
                  >
                    {isEditMode ? "Cancelar Edição" : "Modo Edição"}
                  </button>
                )}
              </h3>

              {isEditMode ? (
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0 mt-0">
                      Modo de edição de perguntas frequentes (FAQ)
                    </h5>
                    <div>
                      <button
                        className="btn btn-primary mr-2"
                        onClick={createNewQuestion}
                        disabled={loading} // <-- evita criar enquanto salva
                      >
                        <FaPlus className="mr-1" /> Criar nova pergunta
                      </button>
                    </div>
                  </div>
                  <div>
                    <ul className="list-group">
                      {editingQuestions.map((question, index) => (
                        <li key={question.id ?? index} className="list-group-item">
                          <div
                            className="d-flex justify-content-between align-items-center"
                            onClick={() => !loading && toggleEditQuestion(index)}
                            style={{ cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1 }}
                          >
                            <h6 className="mb-0 mt-0">
                              {question.isNew
                                ? question.question?.trim() || "Nova pergunta"
                                : question.question}
                              {question.isNew && (
                                <span className="badge bg-info ml-2" style={{ marginLeft: 8 }}>
                                  Novo
                                </span>
                              )}
                            </h6>
                            {selectedEditIndex === index ? <BiChevronUp /> : <BiChevronDown />}
                          </div>

                          {selectedEditIndex === index && (
                            <div className="mt-3">
                              <div className="form-group">
                                <label
                                  htmlFor={`question-${index}`}
                                  style={{ color: "#002C6C", fontSize: "15px", marginBottom: "-5px", fontWeight: "600" }}
                                  className="form-label"
                                >
                                  Pergunta
                                </label>
                                <textarea
                                  id={`question-${index}`}
                                  className="form-control"
                                  rows={3}
                                  placeholder="Edite a pergunta"
                                  title="Editar pergunta"
                                  value={question.question}
                                  onChange={(e) => updateQuestion(index, "question", e.target.value)}
                                  onClick={(e) => e.stopPropagation()}
                                  disabled={loading}
                                />
                              </div>
                              <div className="form-group">
                                <label
                                  htmlFor={`answer-${index}`}
                                  className="form-label"
                                  style={{ color: "#002C6C", fontSize: "15px", marginBottom: "-5px", fontWeight: "600" }}
                                >
                                  Resposta
                                </label>
                                <textarea
                                  id={`answer-${index}`}
                                  className="form-control"
                                  rows={6}
                                  placeholder="Edite a resposta"
                                  title="Editar resposta"
                                  value={question.answer}
                                  onChange={(e) => updateQuestion(index, "answer", e.target.value)}
                                  onClick={(e) => e.stopPropagation()}
                                  disabled={loading}
                                />
                              </div>
                              <div className="form-group">
                                <div className="form-check">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`enabled-${index}`}
                                    checked={!!question.enabled}
                                    onChange={(e) => updateQuestion(index, "enabled", e.target.checked)}
                                    onClick={(e) => e.stopPropagation()}
                                    disabled={loading}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`enabled-${index}`}
                                    style={{ color: "#002C6C", fontSize: "15px", marginBottom: "-5px", fontWeight: "600" }}
                                  >
                                    Habilitado
                                  </label>
                                </div>
                              </div>
                              <div className="d-flex justify-content-between mt-3">
                                {question.isNew ? (
                                  <button
                                    className="btn btn-danger"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      deleteQuestion(index);
                                    }}
                                    disabled={loading}
                                  >
                                    <FaTrash className="mr-1" /> Excluir
                                  </button>
                                ) : (
                                  <span className="text-muted" style={{ alignSelf: "center", fontSize: 12 }}></span>
                                )}

                                <button
                                  className="btn btn-primary"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    saveEditedQuestion(index);
                                  }}
                                  disabled={
                                    loading ||
                                    (question.question ?? "").trim().length === 0 ||
                                    (question.answer ?? "").trim().length === 0
                                  }
                                  title={
                                    loading
                                      ? "Aguarde o processamento"
                                      : (question.question ?? "").trim().length === 0 ||
                                        (question.answer ?? "").trim().length === 0
                                      ? "Preencha pergunta e resposta"
                                      : "Salvar"
                                  }
                                >
                                  <FaSave className="mr-1" /> Salvar
                                </button>
                              </div>
                            </div>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ) : (
                <ul style={{ padding: 0, margin: 0 }} className="list-unstyled accordion" id="accordionFaq">
                  {questions.map((question, index) => (
                    <AccordionFaq
                      isTable={false}
                      key={question.id ?? index}
                      question={question.question}
                      answer={question.answer}
                      show={true}
                      id={index}
                      active={selectedIndex === index}
                      onClickQuestion={(id: number) => changeSelectedIndex(id)}
                    />
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Faq;
